import { render, staticRenderFns } from "./LinkTable.vue?vue&type=template&id=08422684&scoped=true&"
import script from "./LinkTable.vue?vue&type=script&lang=js&"
export * from "./LinkTable.vue?vue&type=script&lang=js&"
import style0 from "./LinkTable.vue?vue&type=style&index=0&id=08422684&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08422684",
  null
  
)

export default component.exports